import Radar from 'radar-sdk-js';

import { log } from '../radar-logger';

// ─── Helpers ────────────────────────────────────────────────────────────────

/**
 * Sets the user ID on the Radar SDK for user tracking.
 * @see {@link https://docs.radar.com/sdk/web#identify-user Identify user | Web}
 */
export function setRadarUserId(userId: string): void {
  try {
    Radar.setUserId(userId);
  } catch (error) {
    log.error('Failed to set Radar user ID', error);
  }
}
